var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrayofstringsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#ECECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 15.5V4.5H6.70148V5.38249H5.15229V14.6175H6.70148V15.5H4Z",
    fill: "#2F3245"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.96879 13.3746C9.44813 13.3746 8.96161 13.3083 8.50923 13.1757C8.06538 13.0431 7.69836 12.8525 7.40815 12.604L7.77944 11.8209C8.09526 12.0529 8.44094 12.2311 8.8165 12.3554C9.2006 12.4714 9.59323 12.5294 9.9944 12.5294C10.4809 12.5294 10.8479 12.4424 11.0955 12.2684C11.3515 12.0944 11.4796 11.8623 11.4796 11.5723C11.4796 11.3403 11.3985 11.1539 11.2363 11.013C11.0741 10.8721 10.8181 10.7685 10.4681 10.7023L9.25181 10.4661C8.70554 10.3418 8.29157 10.1429 8.0099 9.86949C7.73677 9.58776 7.6002 9.22731 7.6002 8.78814C7.6002 8.42354 7.70263 8.10038 7.90748 7.81864C8.11233 7.52863 8.40253 7.3049 8.77809 7.14746C9.16219 6.98173 9.6103 6.89887 10.1224 6.89887C10.5919 6.89887 11.0272 6.96516 11.4284 7.09774C11.8381 7.23032 12.1752 7.42505 12.4398 7.68192L12.0557 8.44011C11.7911 8.21638 11.4924 8.04652 11.1595 7.93051C10.8351 7.80621 10.5023 7.74407 10.1608 7.74407C9.66578 7.74407 9.29876 7.83936 9.05976 8.02994C8.82077 8.21224 8.70127 8.45254 8.70127 8.75085C8.70127 8.97458 8.77383 9.16102 8.91893 9.31017C9.06403 9.45104 9.29876 9.55876 9.62311 9.63333L10.8394 9.86949C11.4113 9.9855 11.8423 10.1761 12.1325 10.4412C12.4227 10.7064 12.5678 11.0586 12.5678 11.4977C12.5678 11.8872 12.4569 12.2228 12.235 12.5045C12.0216 12.7863 11.7186 13.0017 11.3259 13.1508C10.9418 13.3 10.4895 13.3746 9.96879 13.3746Z",
    fill: "#2F3245"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3113 15.5V14.6175H14.8477V5.38249H13.3113V4.5H16V15.5H13.3113Z",
    fill: "#2F3245"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrayofstringsIcon);
export default __webpack_public_path__ + "static/media/arrayofstringsIcon.a9ef9e10.svg";
export { ForwardRef as ReactComponent };